<app-breadcrumb [title]="title" [breadcrumbs]="breadcrumbs"></app-breadcrumb>
<app-responses filterBy="user-profile" hideFilterBy=true [groupId]="groupId" [excludeColumns]="excludeColumns"></app-responses>
<paper-fab routerLink="new" mat-raised-button icon="add" color="accent" class="action">
</paper-fab>
